/**
 * Rodapé do site — HTML/CSS compartilhado entre visualização e exportação.
 * O palco usa as mesmas classes em RenderSiteFooter.
 */

const SVG_ATTR = 'xmlns="http://www.w3.org/2000/svg" width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" aria-hidden="true"';

const SOCIAL_SVG = {
  instagram: `<svg ${SVG_ATTR}><rect x="3" y="3" width="18" height="18" rx="5"/><circle cx="12" cy="12" r="4"/><circle cx="17.5" cy="6.5" r="1" fill="currentColor" stroke="none"/></svg>`,
  facebook: `<svg ${SVG_ATTR}><path d="M18 2h-3a5 5 0 0 0-5 5v3H7v4h3v8h4v-8h3l1-4h-4V7a1 1 0 0 1 1-1h3z"/></svg>`,
  youtube: `<svg ${SVG_ATTR}><path d="M22.5 6.5a2.8 2.8 0 0 0-2-2C18.8 4 12 4 12 4s-6.8 0-8.5.5a2.8 2.8 0 0 0-2 2A29 29 0 0 0 1 12a29 29 0 0 0 .5 5.5 2.8 2.8 0 0 0 2 2C5.2 20 12 20 12 20s6.8 0 8.5-.5a2.8 2.8 0 0 0 2-2A29 29 0 0 0 23 12a29 29 0 0 0-.5-5.5z"/><polygon points="10 15 15 12 10 9 10 15" fill="currentColor" stroke="none"/></svg>`,
  linkedin: `<svg ${SVG_ATTR}><path d="M16 8a6 6 0 0 1 6 6v7h-4v-7a2 2 0 0 0-4 0v7h-4v-7a6 6 0 0 1 6-6z"/><rect x="2" y="9" width="4" height="12"/><circle cx="4" cy="4" r="2"/></svg>`,
  x: `<svg ${SVG_ATTR}><path d="M4 4l16 16M20 4L4 20"/></svg>`,
  whatsapp: `<svg ${SVG_ATTR}><path d="M20 11.5A8.5 8.5 0 0 1 7.4 18.7L3 20l1.4-4.2A8.5 8.5 0 1 1 20 11.5z"/><path d="M8.5 9.5c.2 1.6 1.4 3.2 3.2 4.2 1 .5 1.6.4 2.1-.1l.6-.7c.2-.2.4-.2.6-.1l1.6.8c.2.1.3.3.2.5-.2.8-1 1.4-1.8 1.4-2.4 0-5.2-2.6-6.2-4.8-.6-1.3-.4-2.2.2-2.8.2-.2.4-.2.5-.1l.8.4c.2.1.2.3.1.5z"/></svg>`,
  tiktok: `<svg ${SVG_ATTR}><path d="M14 4v10.2a3.2 3.2 0 1 1-2.2-3V8.2A6.2 6.2 0 0 0 16 9.5V6.2A8 8 0 0 1 14 4z"/></svg>`,
  email: `<svg ${SVG_ATTR}><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>`,
};

const CONTACT_SVG = {
  phone: `<svg ${SVG_ATTR} width="16" height="16"><path d="M22 16.9v3a2 2 0 0 1-2.2 2 19.8 19.8 0 0 1-8.6-3.1 19.5 19.5 0 0 1-6-6 19.8 19.8 0 0 1-3.1-8.7A2 2 0 0 1 4.1 2h3a2 2 0 0 1 2 1.7c.1.9.3 1.8.6 2.6a2 2 0 0 1-.5 2.1L8.1 9.5a16 16 0 0 0 6 6l1.1-1.1a2 2 0 0 1 2.1-.5c.8.3 1.7.5 2.6.6a2 2 0 0 1 1.7 2z"/></svg>`,
  email: `<svg ${SVG_ATTR} width="16" height="16"><rect x="3" y="5" width="18" height="14" rx="2"/><path d="m3 7 9 6 9-6"/></svg>`,
  address: `<svg ${SVG_ATTR} width="16" height="16"><path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0z"/><circle cx="12" cy="10" r="3"/></svg>`,
};

export const SITE_FOOTER_NETWORKS = ['instagram', 'facebook', 'youtube', 'linkedin', 'x', 'whatsapp', 'tiktok', 'email'];

export const SITE_FOOTER_CSS = `
.madri-site-footer{box-sizing:border-box;background:var(--sf-bg,#0f172a);color:var(--sf-text,#e2e8f0);font-family:inherit}
.madri-site-footer--full{width:100vw;max-width:100vw;margin-left:calc(50% - 50vw);margin-right:calc(50% - 50vw)}
.madri-site-footer__inner{max-width:1200px;margin:0 auto;padding:48px 24px 8px;box-sizing:border-box}
.madri-site-footer--boxed .madri-site-footer__inner,.madri-site-footer--boxed .madri-site-footer__bar-inner{max-width:none}
.madri-site-footer__main{display:grid;gap:32px 28px;align-items:start}
.madri-site-footer__brand{display:flex;flex-direction:column;gap:12px;min-width:0}
.madri-site-footer__logo,.madri-site-footer a.madri-site-footer__logo,.madri-moodle-layout .madri-site-footer a.madri-site-footer__logo{display:inline-flex;align-items:center;color:var(--sf-heading,#fff) !important;text-decoration:none;font-weight:700;font-size:20px;line-height:1}
.madri-moodle-layout .madri-site-footer__logo img,.madri-site-footer__logo img{height:var(--sf-logo-h,42px) !important;width:auto !important;max-width:180px;object-fit:contain;display:block;border-radius:0 !important}
.madri-site-footer__about,.madri-site-footer__contact,.madri-site-footer__copy{color:var(--sf-muted,#94a3b8);font-size:14px;line-height:1.6;margin:0}
.madri-site-footer__contact{display:flex;flex-direction:column;gap:8px;list-style:none !important;padding:0 !important}
.madri-site-footer__contact li,.madri-moodle-layout .madri-site-footer__contact li{display:flex;align-items:flex-start;gap:8px;list-style:none !important}
.madri-site-footer__contact svg{flex:0 0 auto;margin-top:2px}
.madri-site-footer__menus{display:contents}
.madri-site-footer__col{min-width:0}
.madri-site-footer__title{margin:0 0 12px;color:var(--sf-heading,#fff);font-size:13px;font-weight:700;letter-spacing:.04em;text-transform:uppercase}
.madri-site-footer__list,.madri-site-footer__legal,.madri-moodle-layout .madri-site-footer__list,.madri-moodle-layout .madri-site-footer__legal{list-style:none !important;margin:0 !important;padding:0 !important}
.madri-site-footer li,.madri-moodle-layout .madri-site-footer li{list-style:none !important}
.madri-site-footer li::marker,.madri-moodle-layout .madri-site-footer li::marker{content:none !important}
.madri-site-footer__list a,.madri-site-footer__legal a,.madri-site-footer__contact a,.madri-moodle-layout .madri-site-footer a{color:var(--sf-link,#cbd5e1) !important;text-decoration:none !important}
.madri-site-footer a:hover,.madri-moodle-layout .madri-site-footer a:hover{color:var(--sf-hover,#fff) !important}
.madri-site-footer__list a{display:inline-block;padding:4px 0;font-size:var(--sf-size,14px);line-height:1.4}
.madri-site-footer__social{display:flex;flex-direction:column;gap:12px;min-width:0}
.madri-site-footer__icons{display:flex;flex-wrap:wrap;gap:8px}
.madri-site-footer__icon,.madri-site-footer a.madri-site-footer__icon,.madri-moodle-layout .madri-site-footer a.madri-site-footer__icon{display:inline-flex;align-items:center;justify-content:center;width:36px;height:36px;border-radius:999px;background:var(--sf-social-bg,#1e293b);color:var(--sf-social,#fff) !important;text-decoration:none}
.madri-site-footer a.madri-site-footer__icon:hover,.madri-moodle-layout .madri-site-footer a.madri-site-footer__icon:hover{color:var(--sf-social,#fff) !important;opacity:.85}
.madri-site-footer__icon svg{display:block}
.madri-site-footer--plain .madri-site-footer__icon{width:auto;height:auto;padding:4px;border-radius:0;background:transparent}
.madri-site-footer__bar{background:var(--sf-bar,#020617);border-top:1px solid var(--sf-line,#334155);margin-top:28px}
.madri-site-footer__bar-inner{max-width:1200px;margin:0 auto;padding:16px 24px;box-sizing:border-box;display:flex;justify-content:space-between;align-items:center;gap:12px 24px;flex-wrap:wrap}
.madri-site-footer__legal{display:flex;flex-wrap:wrap;gap:8px 16px}
.madri-site-footer__legal a{font-size:13px}
.madri-site-footer--centered .madri-site-footer__main{display:flex;flex-direction:column;align-items:center;text-align:center}
.madri-site-footer--centered .madri-site-footer__menus{display:flex;flex-wrap:wrap;justify-content:center;gap:32px;width:100%}
.madri-site-footer--centered .madri-site-footer__brand,.madri-site-footer--centered .madri-site-footer__social,.madri-site-footer--centered .madri-site-footer__contact li{align-items:center}
.madri-site-footer--centered .madri-site-footer__bar-inner{justify-content:center;text-align:center}
.madri-site-footer--compact .madri-site-footer__inner{padding-top:20px;padding-bottom:8px}
.madri-site-footer--compact .madri-site-footer__main{display:flex;align-items:center;gap:24px;flex-wrap:wrap}
.madri-site-footer--compact .madri-site-footer__about,.madri-site-footer--compact .madri-site-footer__contact,.madri-site-footer--compact .madri-site-footer__title{display:none}
.madri-site-footer--compact .madri-site-footer__menus{display:flex;flex-wrap:wrap;align-items:center;gap:4px 18px;flex:1 1 auto}
.madri-site-footer--compact .madri-site-footer__col{display:flex}
.madri-site-footer--compact .madri-site-footer__list{display:flex;flex-wrap:wrap;gap:4px 18px}
.madri-site-footer--compact .madri-site-footer__social{margin-left:auto}
@media (max-width:860px){
  .madri-site-footer--columns .madri-site-footer__main{grid-template-columns:1fr 1fr !important}
  .madri-site-footer__brand,.madri-site-footer__social{grid-column:1 / -1}
  .madri-site-footer--compact .madri-site-footer__social{margin-left:0}
}
@media (max-width:560px){
  .madri-site-footer--columns .madri-site-footer__main{grid-template-columns:1fr !important}
  .madri-site-footer--compact .madri-site-footer__main{flex-direction:column;align-items:flex-start}
}
${footerMobileCenterCss('@media (max-width:767px)')}
${footerMobileCenterCss('.geppetto-edit-bp-mobile')}
.geppetto-edit-bp-mobile .madri-site-footer--columns .madri-site-footer__main{grid-template-columns:1fr !important}
.geppetto-edit-bp-mobile .madri-site-footer--compact .madri-site-footer__main{flex-direction:column;align-items:flex-start}
.geppetto-edit-bp-mobile .madri-site-footer--compact .madri-site-footer__social{margin-left:0}
.geppetto-edit-bp-mobile .madri-site-footer--compact.madri-site-footer--mobile-center .madri-site-footer__main{align-items:center}
`.replace(/\s+/g, ' ').trim();

function footerMobileCenterCss(scope) {
  const atMedia = scope.startsWith('@');
  const prefix = atMedia ? '' : `${scope} `;
  const rules = `
${prefix}.madri-site-footer--mobile-center{text-align:center}
${prefix}.madri-site-footer--mobile-center .madri-site-footer__brand,
${prefix}.madri-site-footer--mobile-center .madri-site-footer__col,
${prefix}.madri-site-footer--mobile-center .madri-site-footer__social{text-align:center}
${prefix}.madri-site-footer--mobile-center .madri-site-footer__logo{width:100%;justify-content:center}
${prefix}.madri-site-footer--mobile-center .madri-site-footer__contact li,
${prefix}.madri-site-footer--mobile-center .madri-site-footer__icons,
${prefix}.madri-site-footer--mobile-center .madri-site-footer__legal,
${prefix}.madri-site-footer--mobile-center .madri-site-footer__bar-inner{justify-content:center;text-align:center}
${prefix}.madri-site-footer--compact.madri-site-footer--mobile-center .madri-site-footer__main,
${prefix}.madri-site-footer--compact.madri-site-footer--mobile-center .madri-site-footer__menus{align-items:center;justify-content:center}
${prefix}.madri-site-footer--compact.madri-site-footer--mobile-center .madri-site-footer__social{margin-left:0}
`.trim();
  return atMedia ? `${scope}{${rules}}` : rules;
}

function escText(value) {
  return String(value == null ? '' : value)
    .replace(/&/g, '&amp;')
    .replace(/</g, '&lt;')
    .replace(/>/g, '&gt;');
}

function escAttr(value) {
  return escText(value).replace(/"/g, '&quot;');
}

export function footerSocialSvg(network) {
  return SOCIAL_SVG[network] || SOCIAL_SVG.instagram;
}

export function footerColumns(content) {
  return (Array.isArray(content?.columns) ? content.columns : []).filter((col) => {
    const title = String(col?.title || '').trim();
    const links = Array.isArray(col?.links) ? col.links : [];
    return title || links.some((link) => String(link?.label || '').trim());
  }).slice(0, 4);
}

export function footerSocials(content) {
  return (Array.isArray(content?.socials) ? content.socials : []).filter((item) => SITE_FOOTER_NETWORKS.includes(item?.network) && String(item?.href || '').trim());
}

export function footerGridColumns(content) {
  const menus = footerColumns(content).length;
  const social = footerSocials(content).length > 0;
  const parts = ['minmax(200px,1.4fr)'];
  if (menus) parts.push(`repeat(${menus},minmax(110px,1fr))`);
  if (social) parts.push('minmax(150px,.75fr)');
  return parts.join(' ');
}

export function createDefaultSiteFooterContent(labels = {}) {
  const link = (label, href) => ({ label, href, openNewTab: false });
  const year = new Date().getFullYear();
  return {
    layout: 'columns',
    widthMode: 'full',
    socialStyle: 'circle',
    bg: '#0f172a',
    textColor: '#e2e8f0',
    mutedColor: '#94a3b8',
    headingColor: '#ffffff',
    linkColor: '#cbd5e1',
    linkHoverColor: '#ffffff',
    socialBg: '#1e293b',
    socialColor: '#ffffff',
    barBg: '#020617',
    lineColor: '#334155',
    fontSize: 14,
    logoUrl: '',
    logoAlt: labels.logoAlt || 'Logo',
    logoText: labels.logoText || 'Minha escola',
    logoHref: '/',
    logoHeight: 42,
    about: labels.about || 'Educação que acompanha você.',
    phone: labels.phone || '(11) 99999-0000',
    email: labels.email || 'contato@escola.com',
    address: labels.address || 'São Paulo, SP',
    columns: [
      {
        title: labels.colInstitution || 'Institucional',
        links: [
          link(labels.aboutLink || 'Sobre', '#sobre'),
          link(labels.courses || 'Cursos', '#cursos'),
          link(labels.blog || 'Blog', '#blog'),
          link(labels.contact || 'Contato', '#contato'),
        ],
      },
      {
        title: labels.colStudents || 'Alunos',
        links: [
          link(labels.student || 'Área do aluno', '/login/index.php'),
          link(labels.certificates || 'Certificados', '#certificados'),
          link(labels.faq || 'Perguntas frequentes', '#faq'),
        ],
      },
      {
        title: labels.colSupport || 'Suporte',
        links: [
          link(labels.help || 'Central de ajuda', '#ajuda'),
          link(labels.talk || 'Fale conosco', '#contato'),
          link(labels.jobs || 'Trabalhe conosco', '#carreiras'),
        ],
      },
    ],
    socials: [
      { network: 'instagram', href: 'https://instagram.com' },
      { network: 'facebook', href: 'https://facebook.com' },
      { network: 'youtube', href: 'https://youtube.com' },
      { network: 'linkedin', href: 'https://linkedin.com' },
    ],
    socialTitle: labels.socialTitle || 'Redes',
    copyright: labels.copyright || `© ${year} Minha escola. Todos os direitos reservados.`,
    legal: [
      link(labels.privacy || 'Privacidade', '#privacidade'),
      link(labels.terms || 'Termos de uso', '#termos'),
    ],
    marginObj: { top: 0, right: 0, bottom: 0, left: 0 },
  };
}

function linkAttrs(href, openNewTab) {
  const url = String(href || '#').trim() || '#';
  const target = openNewTab && !url.startsWith('#') ? ' target="_blank" rel="noopener noreferrer"' : '';
  return ` href="${escAttr(url)}"${target}`;
}

function renderLinks(links) {
  return (Array.isArray(links) ? links : []).map((link) => {
    const label = String(link?.label || '').trim();
    if (!label) return '';
    return `<li><a${linkAttrs(link.href, link.openNewTab)}>${escText(label)}</a></li>`;
  }).join('');
}

function renderContact(content) {
  const rows = [
    ['phone', content.phone, (value) => `tel:${String(value).replace(/[^\d+]/g, '')}`],
    ['email', content.email, (value) => `mailto:${String(value).trim()}`],
    ['address', content.address, () => ''],
  ];
  const items = rows.map(([key, raw, hrefOf]) => {
    const value = String(raw || '').trim();
    if (!value) return '';
    const href = hrefOf(value);
    const inner = href
      ? `<a${linkAttrs(href, false)}>${escText(value)}</a>`
      : escText(value);
    return `<li>${CONTACT_SVG[key] || ''}<span>${inner}</span></li>`;
  }).join('');
  return items ? `<ul class="madri-site-footer__contact">${items}</ul>` : '';
}

export function buildSiteFooterInnerHtml(content) {
  const c = content || {};
  const layout = ['columns', 'centered', 'compact'].includes(c.layout) ? c.layout : 'columns';
  const widthMode = c.widthMode === 'boxed' ? 'boxed' : 'full';
  const socialStyle = c.socialStyle === 'plain' ? 'plain' : 'circle';
  const logoUrl = String(c.logoUrl || '').trim();
  const logoAlt = escAttr(c.logoAlt || c.logoText || 'Logo');
  const logoInner = logoUrl
    ? `<img src="${escAttr(logoUrl)}" alt="${logoAlt}">`
    : escText(c.logoText || 'Logo');
  const logoHref = String(c.logoHref || '').trim();
  const logo = logoHref
    ? `<a class="madri-site-footer__logo"${linkAttrs(logoHref, false)}>${logoInner}</a>`
    : `<span class="madri-site-footer__logo">${logoInner}</span>`;
  const about = String(c.about || '').trim();
  const aboutHtml = about ? `<div class="madri-site-footer__about">${escText(about)}</div>` : '';
  const columns = footerColumns(c).map((col) => {
    const title = String(col.title || '').trim();
    return `<div class="madri-site-footer__col">${title ? `<div class="madri-site-footer__title">${escText(title)}</div>` : ''}<ul class="madri-site-footer__list">${renderLinks(col.links)}</ul></div>`;
  }).join('');
  const socials = footerSocials(c).map((item) => {
    const name = item.network;
    return `<a class="madri-site-footer__icon" aria-label="${escAttr(name)}"${linkAttrs(item.href, true)}>${footerSocialSvg(name)}</a>`;
  }).join('');
  const socialTitle = String(c.socialTitle || '').trim();
  const socialHtml = socials
    ? `<div class="madri-site-footer__social">${socialTitle && layout !== 'compact' ? `<div class="madri-site-footer__title">${escText(socialTitle)}</div>` : ''}<div class="madri-site-footer__icons">${socials}</div></div>`
    : '';
  const copy = String(c.copyright || '').trim();
  const legal = renderLinks(c.legal);
  const bar = (copy || legal)
    ? `<div class="madri-site-footer__bar"><div class="madri-site-footer__bar-inner">${copy ? `<div class="madri-site-footer__copy">${escText(copy)}</div>` : ''}${legal ? `<ul class="madri-site-footer__legal">${legal}</ul>` : ''}</div></div>`
    : '';
  const mainStyle = layout === 'columns' ? ` style="grid-template-columns:${footerGridColumns(c)}"` : '';
  const vars = [
    `--sf-bg:${c.bg || '#0f172a'}`,
    `--sf-text:${c.textColor || '#e2e8f0'}`,
    `--sf-muted:${c.mutedColor || '#94a3b8'}`,
    `--sf-heading:${c.headingColor || '#ffffff'}`,
    `--sf-link:${c.linkColor || '#cbd5e1'}`,
    `--sf-hover:${c.linkHoverColor || '#ffffff'}`,
    `--sf-social-bg:${c.socialBg || '#1e293b'}`,
    `--sf-social:${c.socialColor || '#ffffff'}`,
    `--sf-bar:${c.barBg || '#020617'}`,
    `--sf-line:${c.lineColor || '#334155'}`,
    `--sf-size:${Number(c.fontSize) || 14}px`,
    `--sf-logo-h:${Number(c.logoHeight) || 42}px`,
  ].join(';');
  const classes = [
    'madri-site-footer',
    `madri-site-footer--${layout}`,
    `madri-site-footer--${widthMode}`,
    socialStyle === 'plain' ? 'madri-site-footer--plain' : '',
    c.responsive?.mobile?.centerOnMobile ? 'madri-site-footer--mobile-center' : '',
  ].filter(Boolean).join(' ');
  return `<div class="madri-site-footer-slot"><style>${SITE_FOOTER_CSS}</style><footer class="${classes}" style="${escAttr(vars)}"><div class="madri-site-footer__inner"><div class="madri-site-footer__main"${mainStyle}><div class="madri-site-footer__brand">${logo}${aboutHtml}${renderContact(c)}</div><div class="madri-site-footer__menus">${columns}</div>${socialHtml}</div></div>${bar}</footer></div>`;
}
